import React, { useState } from "react";
import Tooltip from "../Tooltip/Tooltip";

type BarProgressProps = {
  label?: string;
  score: number;
  text: string;
};

const BarProgress = (props: BarProgressProps) => {
  const { label, score, text } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const colorHandler = (score: number) => {
    if (score > 0 && score < 59) {
      return "bg-red-500";
    } else if (score > 60 && score < 79) {
      return "bg-yellow-500";
    } else {
      return "bg-green-500";
    }
  };

  return (
    <div className="w-full">
      <div className="flex sm:w-[300px] w-[250px] items-center justify-between mb-1">
        <div className="text-sm text-[gray] flex items-center space-x-2">
          <div> {label} </div>
          <Tooltip
            text={text}
            open={open}
            handleClose={handleClose}
            handleOpen={handleOpen}
          />
        </div>
        <div className="text-sm text-blue-900">{score}/100</div>
      </div>
      <div className="h-2 sm:w-[300px] w-[250px] bg-gray-300 relative rounded-full ">
        <div
          style={{ width: `${score * 3}px` }}
          className={`h-2 ${colorHandler(
            score
          )} absolute left-0 top-0 rounded-full sm:block hidden`}
        ></div>
        <div
          style={{ width: `${score * 2.5}px` }}
          className={`h-2 ${colorHandler(
            score
          )} absolute left-0 top-0 rounded-full sm:hidden block`}
        ></div>
      </div>
    </div>
  );
};

export default BarProgress;
